export const localSeoPages = [
  {
    slug: 'cctv-camera-bhubaneswar',
    label: 'CCTV Camera in Bhubaneswar',
    title: 'CCTV Camera in Bhubaneswar | IP, Dome, Bullet and PTZ Cameras | Camigo',
    description: 'Buy CCTV cameras in Bhubaneswar from Camigo. Shop IP cameras, dome cameras, bullet cameras, PTZ cameras, DVRs, NVRs, PoE switches, and CCTV setup packages with local support.',
    eyebrow: 'Local CCTV Shopping',
    heroTitle: 'CCTV camera dealer and online CCTV buying support in Bhubaneswar.',
    lead: 'Camigo helps customers looking for CCTV cameras in Bhubaneswar compare products, choose setup packages, and buy surveillance gear for homes, shops, offices, apartments, and warehouses.',
    areaServed: ['Bhubaneswar', 'Patia', 'Khandagiri', 'Nayapalli', 'Chandrasekharpur', 'Saheed Nagar'],
    bullets: [
      'IP cameras for sharper image quality and PoE-enabled setups.',
      'Dome cameras for indoor homes, offices, and ceiling-mount surveillance needs.',
      'Bullet cameras for gates, perimeters, shops, and outdoor monitoring.',
      'PTZ cameras for wide-area monitoring, zoom, and remote control.',
      'DVRs, NVRs, PoE switches, SMPS units, and CCTV accessories for complete setups.'
    ],
    searchText: 'This page is useful for people searching online for CCTV camera dealers in Bhubaneswar, CCTV camera shops, home CCTV camera setups, office surveillance systems, and CCTV accessories with local dispatch and support.',
    coverageText: 'Camigo is positioned for local CCTV buying searches from Patia, Khandagiri, Nayapalli, Rasulgarh, Saheed Nagar, Chandrasekharpur, Old Town, Jharapada, and nearby Bhubaneswar service belts.',
    faqTitle: 'CCTV Camera Bhubaneswar FAQs',
    faqEyebrow: 'Common questions',
    faqs: [
      {
        question: 'Can I buy CCTV cameras in Bhubaneswar directly from Camigo?',
        answer: 'Yes. Camigo helps Bhubaneswar customers buy CCTV cameras, DVRs, NVRs, accessories, and setup packages online with local delivery and support.'
      },
      {
        question: 'What types of CCTV cameras are available in Bhubaneswar?',
        answer: 'Camigo offers IP cameras, dome cameras, bullet cameras, PTZ cameras, DVRs, NVRs, PoE switches, SMPS units, and CCTV accessories for homes, offices, and shops.'
      },
      {
        question: 'Does Camigo support local CCTV delivery in Bhubaneswar?',
        answer: 'Yes. Eligible Bhubaneswar locations can see fast local dispatch estimates, while other Odisha destinations may be served by courier based on zone and product availability.'
      }
    ],
    internalLinks: [
      { to: '/category/2', label: 'Browse IP cameras in Bhubaneswar' },
      { to: '/category/3', label: 'Explore PTZ cameras for offices and warehouses' },
      { to: '/shop', label: 'View all CCTV products' },
      { to: '/security-camera-odisha', label: 'See Odisha-wide CCTV buying support' }
    ]
  },
  {
    slug: 'cctv-installation-bhubaneswar',
    label: 'CCTV Installation in Bhubaneswar',
    title: 'CCTV Installation in Bhubaneswar | Home, Office and Shop Setup | Camigo',
    description: 'Book or plan CCTV installation in Bhubaneswar with Camigo. Get support for home CCTV setup, office surveillance, shop camera installation, and complete recorder or accessories planning.',
    eyebrow: 'Local Installation Support',
    heroTitle: 'CCTV installation support in Bhubaneswar for homes, shops, offices, and warehouses.',
    lead: 'Camigo supports customers searching for CCTV installation in Bhubaneswar by helping them plan cameras, recorders, accessories, and setup packages together.',
    areaServed: ['Bhubaneswar', 'Patia', 'Khandagiri', 'Chandrasekharpur', 'Saheed Nagar', 'Old Town', 'Cuttack', 'Khordha'],
    bullets: [
      'Home CCTV installation for entrances, parking, terraces, and common access points.',
      'Office and shop camera installation for counters, entry control, and asset monitoring.',
      'Apartment and warehouse surveillance planning with recorders, power, and networking accessories.',
      'Multi-camera setups using DVR, NVRs, PoE switches, and bundled setup packages.'
    ],
    searchText: 'This page is designed for searches like CCTV installation near me in Bhubaneswar, home CCTV installation Bhubaneswar, office CCTV installation, shop camera installation, and CCTV setup support in Odisha.',
    coverageText: 'Camigo is relevant for searches from Patia, Khandagiri, Chandrasekharpur, Saheed Nagar, Old Town, Cuttack, and Khordha, where customers frequently look for home CCTV installation, office surveillance setup, shop camera fitting, and recorder plus accessory planning.',
    faqTitle: 'CCTV Installation Bhubaneswar FAQs',
    faqEyebrow: 'Before you book',
    faqs: [
      {
        question: 'Does Camigo support CCTV installation in Bhubaneswar?',
        answer: 'Yes. Camigo supports CCTV installation workflows in Bhubaneswar for eligible orders, depending on product type, service coverage, and scheduling availability.'
      },
      {
        question: 'Can I buy products and installation together?',
        answer: 'Yes. Customers can buy cameras, recorders, switches, accessories, or setup packages first and then use Camigo\'s installation support paths for eligible service areas.'
      },
      {
        question: 'What places can use CCTV installation support?',
        answer: 'Camigo\'s installation support is suited for homes, offices, shops, apartments, warehouses, and other practical surveillance projects in and around Bhubaneswar.'
      }
    ],
    internalLinks: [
      { to: '/install', label: 'Open the CCTV installation page' },
      { to: '/category/2', label: 'Check IP camera options for installation' },
      { to: '/shop', label: 'Browse the full CCTV catalog' },
      { to: '/security-camera-odisha', label: 'Read Odisha CCTV support coverage' }
    ]
  },
  {
    slug: 'security-camera-odisha',
    label: 'Security Camera in Odisha',
    title: 'Security Camera in Odisha | CCTV Cameras, DVRs and Installation Support | Camigo',
    description: 'Buy security cameras in Odisha with Camigo. Browse CCTV cameras, PTZ cameras, DVRs, NVRs, PoE switches, and setup packages with Bhubaneswar-based support and Odisha delivery coverage.',
    eyebrow: 'Odisha Coverage',
    heroTitle: 'Security camera supply and CCTV buying support across Odisha.',
    lead: 'Camigo is positioned for people searching across Odisha for security cameras, CCTV camera dealers, recorder systems, and setup accessories.',
    areaServed: ['Bhubaneswar', 'Cuttack', 'Khordha', 'Puri', 'Berhampur', 'Rourkela', 'Sambalpur', 'Balasore'],
    bullets: [
      'IP cameras, dome cameras, bullet cameras, and PTZ cameras.',
      'DVR and NVR recorders for small, medium, and larger surveillance setups.',
      'PoE switches, SMPS units, connectors, cables, and CCTV accessories.',
      'Setup packages for common home, office, and commercial CCTV needs.'
    ],
    searchText: 'This page is designed for searches such as security camera in Odisha, CCTV camera Odisha, CCTV dealer Odisha, CCTV installation Odisha, and business or home surveillance product sourcing from an Odisha-based supplier.',
    coverageText: 'Camigo is relevant for CCTV and security camera searches from Bhubaneswar, Cuttack, Khordha, Puri, Berhampur, Rourkela, Sambalpur, and Balasore, including buyers who want an Odisha supplier for cameras, recorders, power accessories, and setup planning.',
    faqTitle: 'Security Camera Odisha FAQs',
    faqEyebrow: 'Popular queries',
    faqs: [
      {
        question: 'Does Camigo serve customers outside Bhubaneswar in Odisha?',
        answer: 'Yes. Camigo can serve Odisha customers through local dispatch where available and courier-supported fulfillment for supported zones outside the fastest local corridor.'
      },
      {
        question: 'What security camera products can Odisha customers buy from Camigo?',
        answer: 'Odisha customers can browse IP cameras, dome cameras, bullet cameras, PTZ cameras, DVRs, NVRs, PoE switches, power supplies, and setup packages.'
      },
      {
        question: 'Can Odisha businesses order CCTV systems online?',
        answer: 'Yes. Camigo supports homes, offices, retail shops, warehouses, and installer-led buying workflows for surveillance products across Odisha.'
      }
    ],
    internalLinks: [
      { to: '/shop', label: 'Browse all CCTV products in Odisha' },
      { to: '/cctv-camera-bhubaneswar', label: 'See the Bhubaneswar CCTV camera page' },
      { to: '/cctv-installation-bhubaneswar', label: 'See Bhubaneswar installation support' },
      { to: '/about-camigo', label: 'Learn about Camigo and local support' }
    ]
  },
  {
    slug: 'cctv-dealer-bhubaneswar',
    label: 'CCTV Dealer in Bhubaneswar',
    title: 'CCTV Dealer in Bhubaneswar | Cameras, DVRs, NVRs and Accessories | Camigo',
    description: 'Looking for a CCTV dealer in Bhubaneswar? Camigo supplies CCTV cameras, DVRs, NVRs, PoE switches, accessories, and setup packages for homes, offices, shops, and installers.',
    eyebrow: 'Dealer Search Intent',
    heroTitle: 'A practical CCTV dealer page for Bhubaneswar buyers and installers.',
    lead: 'Camigo serves people looking for a CCTV dealer in Bhubaneswar with product catalog depth, installation-linked buying support, and local order convenience.',
    areaServed: ['Bhubaneswar', 'Patia', 'Khandagiri', 'Saheed Nagar', 'Rasulgarh'],
    bullets: [
      'CCTV cameras for homes, offices, shops, and warehouse projects.',
      'Recorder options including DVRs and NVRs.',
      'Power, switching, and accessories for complete installations.',
      'Setup packages for faster bundled buying.'
    ],
    searchText: 'This page is designed for people searching CCTV dealer Bhubaneswar, CCTV shop in Bhubaneswar, CCTV supplier Bhubaneswar, and local surveillance product dealers.',
    coverageText: 'Camigo aims to be discoverable for CCTV dealer searches from Patia, Khandagiri, Saheed Nagar, Rasulgarh, and nearby Bhubaneswar business zones.',
    faqTitle: 'CCTV Dealer Bhubaneswar FAQs',
    faqEyebrow: 'Dealer-related queries',
    faqs: [
      {
        question: 'Is Camigo useful for installer and dealer-style buying?',
        answer: 'Yes. Camigo supports larger product sourcing needs with recorders, cameras, accessories, and setup packages suited to installer and repeat-buying workflows.'
      },
      {
        question: 'Can I compare multiple CCTV categories in one place?',
        answer: 'Yes. The catalog includes AHD cameras, IP cameras, PTZ cameras, DVRs, NVRs, switches, SMPS units, and accessories.'
      }
    ],
    internalLinks: [
      { to: '/shop', label: 'Open the full Camigo product catalog' },
      { to: '/category/1', label: 'See AHD camera options' },
      { to: '/category/2', label: 'See IP camera options' },
      { to: '/category/3', label: 'See PTZ camera options' }
    ]
  },
  {
    slug: 'ip-camera-bhubaneswar',
    label: 'IP Camera in Bhubaneswar',
    title: 'IP Camera in Bhubaneswar | PoE and Smart CCTV Camera Options | Camigo',
    description: 'Buy IP cameras in Bhubaneswar from Camigo. Compare PoE-ready security cameras, indoor and outdoor IP camera options, recorder compatibility, and accessories.',
    eyebrow: 'IP Camera Search',
    heroTitle: 'IP camera buying support in Bhubaneswar for modern CCTV setups.',
    lead: 'Camigo helps customers searching for IP cameras in Bhubaneswar compare smarter CCTV options with recorder, power, and networking compatibility in mind.',
    areaServed: ['Bhubaneswar', 'Patia', 'Nayapalli', 'Chandrasekharpur'],
    bullets: [
      'IP cameras for homes, offices, shops, and warehouses.',
      'PoE-friendly models for cleaner cabling and easier network-based setups.',
      'Recorder pairing with NVRs and switching accessories.',
      'Indoor and outdoor formats for surveillance coverage planning.'
    ],
    searchText: 'This page targets searches like IP camera Bhubaneswar, network camera dealer Bhubaneswar, PoE camera Bhubaneswar, and smart CCTV camera Bhubaneswar.',
    coverageText: 'Camigo is relevant for buyers looking for IP cameras in Patia, Nayapalli, Chandrasekharpur, and wider Bhubaneswar locations.',
    faqTitle: 'IP Camera Bhubaneswar FAQs',
    faqEyebrow: 'Popular IP camera queries',
    faqs: [
      {
        question: 'Are IP cameras better for office and shop setups?',
        answer: 'IP cameras are often preferred where sharper image quality, PoE convenience, and modern networking workflows matter more.'
      },
      {
        question: 'Can I buy IP cameras and NVRs together?',
        answer: 'Yes. Camigo supports buying IP cameras with NVRs, PoE switches, and related CCTV accessories in one catalog flow.'
      }
    ],
    internalLinks: [
      { to: '/category/2', label: 'Browse all IP cameras' },
      { to: '/shop', label: 'Open all CCTV products' },
      { to: '/cctv-camera-bhubaneswar', label: 'See the broader Bhubaneswar CCTV page' }
    ]
  },
  {
    slug: 'ptz-camera-bhubaneswar',
    label: 'PTZ Camera in Bhubaneswar',
    title: 'PTZ Camera in Bhubaneswar | Zoom and Wide-Area CCTV Options | Camigo',
    description: 'Looking for PTZ cameras in Bhubaneswar? Camigo helps buyers compare zoom-capable CCTV cameras for warehouses, campuses, gates, offices, and larger surveillance areas.',
    eyebrow: 'PTZ Camera Search',
    heroTitle: 'PTZ camera options in Bhubaneswar for larger sites and zoom coverage.',
    lead: 'Camigo supports PTZ camera buyers in Bhubaneswar who need wider surveillance control, zoom capability, and better site oversight for larger spaces.',
    areaServed: ['Bhubaneswar', 'Khordha', 'Cuttack'],
    bullets: [
      'PTZ cameras for campuses, gates, warehouses, and wide open areas.',
      'Zoom and movement control for focused event review and monitoring.',
      'Recorder and accessory planning for larger surveillance systems.'
    ],
    searchText: 'This page targets searches such as PTZ camera Bhubaneswar, zoom CCTV camera Bhubaneswar, and warehouse or gate surveillance cameras in Bhubaneswar.',
    coverageText: 'Camigo aims to support PTZ camera demand from Bhubaneswar, Khordha, and Cuttack buyers who need stronger wide-area surveillance options.',
    faqTitle: 'PTZ Camera Bhubaneswar FAQs',
    faqEyebrow: 'PTZ search questions',
    faqs: [
      {
        question: 'Where are PTZ cameras most useful?',
        answer: 'PTZ cameras are especially useful for campuses, warehouse yards, gates, long perimeters, and larger monitoring areas where zoom and movement control matter.'
      }
    ],
    internalLinks: [
      { to: '/category/3', label: 'Browse PTZ camera products' },
      { to: '/shop', label: 'Open the full catalog' },
      { to: '/security-camera-odisha', label: 'See Odisha CCTV support page' }
    ]
  },
  {
    slug: 'dvr-nvr-dealer-bhubaneswar',
    label: 'DVR NVR Dealer in Bhubaneswar',
    title: 'DVR and NVR Dealer in Bhubaneswar | CCTV Recorders and Accessories | Camigo',
    description: 'Find DVR and NVR options in Bhubaneswar with Camigo. Compare CCTV recorders, switching accessories, storage-oriented setups, and recorder-compatible camera bundles.',
    eyebrow: 'Recorder Search',
    heroTitle: 'DVR and NVR buying support in Bhubaneswar for recorder-based CCTV systems.',
    lead: 'Camigo helps customers searching for DVR dealers, NVR dealers, and CCTV recorder suppliers in Bhubaneswar compare recorder options with cameras, switches, and accessories.',
    areaServed: ['Bhubaneswar', 'Patia', 'Saheed Nagar', 'Rasulgarh'],
    bullets: [
      'DVRs for analog and upgrade-oriented surveillance systems.',
      'NVRs for IP camera-based CCTV environments.',
      'Recorder planning with channels, storage retention, and expansion in mind.'
    ],
    searchText: 'This page supports searches like DVR dealer Bhubaneswar, NVR dealer Bhubaneswar, CCTV recorder Bhubaneswar, and surveillance storage setup Bhubaneswar.',
    coverageText: 'Camigo is relevant for recorder-related CCTV searches across Bhubaneswar commercial and residential buying zones.',
    faqTitle: 'DVR and NVR Bhubaneswar FAQs',
    faqEyebrow: 'Recorder questions',
    faqs: [
      {
        question: 'Can Camigo help me match a recorder with cameras?',
        answer: 'Yes. Camigo\'s catalog supports recorder-led buying where you compare DVRs or NVRs along with compatible camera and accessory combinations.'
      }
    ],
    internalLinks: [
      { to: '/shop', label: 'Browse DVR and NVR products' },
      { to: '/cctv-dealer-bhubaneswar', label: 'See the Bhubaneswar dealer page' },
      { to: '/category/2', label: 'Check IP camera pairings' }
    ]
  },
  {
    slug: 'home-cctv-installation-bhubaneswar',
    label: 'Home CCTV Installation in Bhubaneswar',
    title: 'Home CCTV Installation in Bhubaneswar | Camera Setup for Houses and Flats | Camigo',
    description: 'Need home CCTV installation in Bhubaneswar? Camigo helps with home camera planning, entrances, terraces, parking, and recorder plus accessories for practical home surveillance setups.',
    eyebrow: 'Home CCTV Intent',
    heroTitle: 'Home CCTV installation planning in Bhubaneswar for houses, flats, and apartments.',
    lead: 'Camigo supports customers searching for home CCTV installation in Bhubaneswar by combining product selection with installation-oriented planning for common residential use cases.',
    areaServed: ['Bhubaneswar', 'Patia', 'Old Town', 'Chandrasekharpur'],
    bullets: [
      'Entrance and gate monitoring cameras.',
      'Parking, terrace, and stair access coverage planning.',
      'Recorder and power matching for practical residential CCTV systems.'
    ],
    searchText: 'This page targets searches such as home CCTV installation Bhubaneswar, house camera installation Bhubaneswar, and apartment CCTV setup Bhubaneswar.',
    coverageText: 'Camigo is relevant for home CCTV searches across Patia, Old Town, Chandrasekharpur, and wider Bhubaneswar residential areas.',
    faqTitle: 'Home CCTV Installation Bhubaneswar FAQs',
    faqEyebrow: 'Residential setup questions',
    faqs: [
      {
        question: 'What is common in a home CCTV setup?',
        answer: 'Most home setups combine entrance, parking, or terrace cameras with a recorder and basic power or networking accessories depending on the chosen camera type.'
      }
    ],
    internalLinks: [
      { to: '/install', label: 'Open the installation page' },
      { to: '/cctv-installation-bhubaneswar', label: 'See broader installation support' },
      { to: '/shop', label: 'Browse home CCTV products' }
    ]
  },
  {
    slug: 'office-cctv-installation-bhubaneswar',
    label: 'Office CCTV Installation in Bhubaneswar',
    title: 'Office CCTV Installation in Bhubaneswar | Office Surveillance Setup | Camigo',
    description: 'Camigo helps businesses planning office CCTV installation in Bhubaneswar. Compare office cameras, recorders, PoE switches, and accessories for workspace surveillance systems.',
    eyebrow: 'Office Surveillance Intent',
    heroTitle: 'Office CCTV installation support in Bhubaneswar for workspaces and business sites.',
    lead: 'Camigo supports office CCTV installation searches in Bhubaneswar by helping businesses choose cameras, recorders, and switching accessories for reliable surveillance planning.',
    areaServed: ['Bhubaneswar', 'Saheed Nagar', 'Rasulgarh', 'Nayapalli'],
    bullets: [
      'Office entry, lobby, reception, and corridor surveillance.',
      'Recorder planning for longer retention and event review.',
      'PoE switch and accessory support for multi-camera office layouts.'
    ],
    searchText: 'This page targets office CCTV installation Bhubaneswar, office surveillance setup Bhubaneswar, business camera installation Bhubaneswar, and workplace CCTV planning.',
    coverageText: 'Camigo is positioned for office CCTV installation intent in Saheed Nagar, Rasulgarh, Nayapalli, and wider Bhubaneswar commercial zones.',
    faqTitle: 'Office CCTV Installation Bhubaneswar FAQs',
    faqEyebrow: 'Business setup questions',
    faqs: [
      {
        question: 'Can Camigo help with office camera and recorder planning?',
        answer: 'Yes. Camigo\'s catalog and support pages are built for office buyers who need cameras, recorders, switches, and accessories as part of a surveillance rollout.'
      }
    ],
    internalLinks: [
      { to: '/shop', label: 'Browse office CCTV products' },
      { to: '/category/2', label: 'Check IP camera options for offices' },
      { to: '/cctv-dealer-bhubaneswar', label: 'See the Bhubaneswar dealer page' }
    ]
  }
];
